import { useDecision } from '@optimizely/react-sdk';

import { DISABLE_DECISION, FLAG } from 'Utilities/analytics/optimizely/constants';
import { useFeatureFlags } from 'Utilities/hooks';

type UseServiceFeeEnabledProps = {
  dpEnquiryId?: number;
  isEligibleForExperiment: boolean;
  useExperimentDecision?: boolean;
};

type UseServiceFeeEnabledReturn = {
  clientReady: boolean;
  isServiceFeeEnabled: boolean;
  isServiceFeeExperimentEnabled: boolean;
  variationKey: string | null;
};

export const useServiceFeeEnabled = ({
  dpEnquiryId,
  isEligibleForExperiment,
  useExperimentDecision = false,
}: UseServiceFeeEnabledProps = { isEligibleForExperiment: false }): UseServiceFeeEnabledReturn => {
  const { showServiceFee } = useFeatureFlags();

  const canTriggerExperiment = isEligibleForExperiment && useExperimentDecision;

  const [{ enabled, variationKey }, clientReady] = useDecision(
    FLAG.MW_SERVICE_FEE,
    { decideOptions: canTriggerExperiment ? [] : DISABLE_DECISION },
    { overrideUserId: dpEnquiryId?.toString() },
  );

  const isServiceFeeExperimentEnabled = canTriggerExperiment
    && clientReady
    && enabled
    && variationKey === 'on';

  return {
    clientReady,
    isServiceFeeEnabled: Boolean(showServiceFee),
    isServiceFeeExperimentEnabled,
    variationKey,
  };
};
